<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      合同基本信息
    </div>
    <div class="rj-page-card__content">
      <el-form ref="form" :model="form" :rules="rules" class="baseInfoForm">
        <div class="rj-row">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订单日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.createTime }}
              </div>
            </div>
          </div>
          <contract-number ref="contractNumber" v-model="form" />
          <supply-unit ref="supplyUnit" v-model="form" required @changesupply="changeSupply" />
          <ordering-unit v-model="form" :is-show-esing="isShowEsing" required @changeOrderUnit="changeOrderUnit" />
          <end-customer v-model="form" required @changeEndUnit="changeEndUnit" />
          <div v-if="isShowEsing" class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                业务类型：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.projectType }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订单分类：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.contractType }}
              </div>
            </div>
          </div>
          <tax-type v-model="form" required @changeTaxType="changeTaxType" />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                净销售额：
              </div>
              <div class="rj-baseinfo__item">
                <!--<el-form-item prop="finalNetSales">-->
                <!--<el-input v-model="form.finalNetSales" placeholder="请输入净销售额" />-->
                <!--</el-form-item>-->
                {{ form.netSales }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                现销或赊销：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="salesType">
                  <el-radio-group v-model="form.salesType">
                    <el-radio v-for="(type,index) in salesType" :key="index" :label="type.code">
                      {{ type.name }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </div>
          <account-period v-model="form" />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                付款方式：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="paymentMethodName">
                  <el-select v-model="form.paymentMethodName" placeholder="请选择付款方式">
                    <el-option v-for="(value, key) in paymentMethod" :key="key" :label="value" :value="key" />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
          <order-type ref="orderType" v-model="form" required />
          <pre-sale ref="preSale" v-model="form" required />
          <export-sale ref="exportSale" v-model="form" required />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                部门：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.departmentName }}
              </div>
            </div>
          </div>
          <region-auto ref="regionAuto" v-model="form" />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                项目代码(CRM编号)：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.opportunityCode }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                项目名称：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="projectName">
                  <el-input v-model="form.projectName" placeholder="请输入项目名称" />
                </el-form-item>
              </div>
            </div>
          </div>
          <region-business ref="regionBusiness" v-model="form" />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                首级集成商名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.integratorName || '无' }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                首级集成商类型：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.integratorType || '无' }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                计量集成商名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.metrologyIntegratorName || '无' }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                计量集成商类型：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.metrologyIntegratorType || '无' }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                末级集成商名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.finalIntegratorsName || '无' }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                末级集成商类型：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.finalIntegratorsType || '无' }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                计量计点：
              </div>
              <div class="rj-baseinfo__item">
                {{ $store.getters['enumeration/getmeteringPoint'](form.meteringPoint) }}
              </div>
            </div>
          </div>
          <market v-if="form.contractType" ref="market" v-model="form" />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                借条单号：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="borrowingOrderNumber">
                  <el-input v-model="form.borrowingOrderNumber" placeholder="请输入借条单号" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                CRM客户编码：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="crmAccountCode">
                  <el-input v-model="form.crmAccountCode" placeholder="请输入CRM客户编码" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                特价标志：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="isSpecialPrice">
                  <el-checkbox v-model="form.isSpecialPrice" />
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <div class="rj-row">
          <payment-bank ref="bank" v-model="form" />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                发货方式：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="shipType">
                  <el-radio-group v-model="form.shipType">
                    <el-radio v-for="(type,index) in shipType" :key="index" disabled :label="type.code">
                      {{ type.name }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </div>
          <rebate-amount v-show="!isShowEsing" ref="rebateAmount" v-model="form" />
          <Discount v-model="form" />
          <div class="rj-col-1">
            <el-form-item prop="regionBusinessCommissionerOpinion" label="区域商务专员意见:">
              <el-input v-model.trim="form.regionBusinessCommissionerOpinion" type="textarea" :rows="3" placeholder="请输入区域商务专员意见" />
            </el-form-item>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="additionalTerms" label="补充条款:">
              <el-input v-model.trim="form.additionalTerms" type="textarea" :rows="3" placeholder="请输入补充条款" />
            </el-form-item>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="serviceTerms" label="服务条款:">
              <el-input v-model.trim="form.serviceTerms" type="textarea" :rows="3" placeholder="请输入服务条款" />
            </el-form-item>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="receiptArrivalAcceptanceRequirements" label="收货回执及到货验收要求:">
              <el-input v-model.trim="form.receiptArrivalAcceptanceRequirements" type="textarea" :rows="3" placeholder="请输入收货回执及到货验收要求" />
            </el-form-item>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="remarks" label="备注说明:">
              <el-input v-model.trim="form.remarks" type="textarea" :rows="3" placeholder="请输入备注说明" />
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script type="es6">
import contractNumber from '../../../contractCommonInput/contractNumber';
import supplyUnit from '../../../contractCommonInput/supplyUnit';
import orderingUnit from '../../../contractCommonInput/orderingUnit';
import EndCustomer from '../../../contractCommonInput/EndCustomer';
import baseInfoMixin from '../../createContract/baseInfoMixin';
import { mapState } from 'vuex';
const orderType = () => import('../../../contractCommonInput/orderType');
const accountPeriod = () => import('../../../contractCommonInput/accountPeriod');
const preSale = () => import('../../../contractCommonInput/preSale');
const exportSale = () => import('../../../contractCommonInput/exportSale');
const regionAuto = () => import('../../../contractCommonInput/regionAuto');
const regionBusiness = () => import('../../../contractCommonInput/regionBusiness');
const market = () => import('../../../contractCommonInput/market');
const paymentBank = () => import('../../../contractCommonInput/paymentBank');
const taxType = () => import('../../../contractCommonInput/taxType');
const rebateAmount = () => import('../../../contractCommonInput/rebateAmount');
const Discount = () => import('../../../contractCommonInput/Discount');
export default {
  mixins: [baseInfoMixin],
  data () {
    var verifyEmail = (rule, value, callback) => {
      if (this.form.contractType === 'SMB分销下单' || this.form.contractType === '服务商分销下单') {
        callback();
      } else {
        if (value === '') {
          callback(new Error('请输入齐套通知打款邮箱'));
        } else {
          callback();
        }
      }
    };
    return {
      loading: false,
      rules: {
        customerContractNum: [
          { required: true, message: '请输入客户合同编号', trigger: 'blur' }
        ],
        projectName: [
          { required: true, message: '请输入项目名称', trigger: 'blur' }
        ],
        supplyUnitId: [
          { required: true, message: '请选择供货单位', trigger: 'change' }
        ],
        orderUnitCode: [
          { required: true, message: '请选择订货单位', trigger: 'change' }
        ],
        finalCustomer: [
          { required: true, message: '请选择最终客户', trigger: 'change' }
        ],
        contractType: [
          { required: true, message: '请选择订单分类', trigger: 'change' }
        ],
        currencyId: [
          { required: true, message: '请选择币种', trigger: 'change' }
        ],
        preSalesCode: [
          { required: true, message: '请选择售前', trigger: 'change' }
        ],
        salesManCode: [
          { required: true, message: '请选择外销', trigger: 'change' }
        ],
        setNoticeMail: [
          { validator: verifyEmail, trigger: 'blur' }
        ]
      }
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    }
  },
  components: {
    contractNumber,
    supplyUnit,
    orderingUnit,
    EndCustomer,
    orderType,
    accountPeriod,
    preSale,
    exportSale,
    regionAuto,
    regionBusiness,
    market,
    paymentBank,
    taxType,
    rebateAmount,
    Discount
  },
  computed: {
    ...mapState({
      moneyType: state => state.enumeration.moneyType,
      salesType: state => state.enumeration.salesType,
      paymentMethod: state => state.enumeration.paymentMethod,
      shipType: state => state.enumeration.shipType,
      isEmbeddedSoftware: state => state.enumeration.isEmbeddedSoftware,
      shanghaiHongkongDiscount: state => state.enumeration.shanghaiHongkongDiscount
    }),
    isShowEsing () {
      // 如果是新ECP && 是服务订单就展示
      return this.form.sources === 'NEW-ECP' && this.form.contractType === '服务订单';
    }
  },
  methods: {
    setInitData () {
      this.$refs.supplyUnit.initData();
      if (this.$refs.exportSale) {
        this.$refs.exportSale.initData();
      }
      if (this.$refs.orderType) {
        this.$refs.orderType.initContratOrderType('');
      }
      if (this.$refs.integrator) {
        this.$refs.integrator.initData();
      }
      if (this.$refs.market) {
        this.$refs.market.initData();
      }
      if (this.$refs.preSale) {
        this.$refs.preSale.initData();
      }
      if (this.$refs.regionAuto) {
        this.$refs.regionAuto.initData();
      }
      if (this.$refs.regionBusiness) {
        this.$refs.regionBusiness.initData();
      }
      if (this.$refs.bank) {
        this.$refs.bank.initData();
      }
    }
  },
  mounted () {

  }
};
</script>
<style lang="scss">
  .baseInfoForm {
    .el-form-item--mini.el-form-item {
      margin-bottom: 0;
    }
  }
</style>
<style lang="scss">
  .baseInfoForm{
    .el-form-item__error{
      position: relative;
    }
  }
  .required{
    color: red;
    margin-left: 3px;
  }
</style>
